<div class="flex gap-4">
  <lib-input
    background="white"
    [placeholder]="'reason_selector_treatment_plan_search' | translate"
    [value]="viewModel().searchQuery"
    (valueChange)="onSearchQueryChange($event)"
  >
    <svg-icon class="text-text-tertiary" key="px-24-search" leftIcon></svg-icon>
  </lib-input>

  <lib-dropdown
    background="white"
    class="w-[280px]"
    [options]="[
      {
        value: TreatmentPlanDialogDate.Recent,
        label: 'reason_selector_treatment_plan_dropdown_recent' | translate
      },
      {
        value: TreatmentPlanDialogDate.Last6Months,
        label: 'charting_treatment_plan_date_last_6_months' | translate
      },
      {
        value: TreatmentPlanDialogDate.Last12Months,
        label: 'charting_treatment_plan_date_last_12_months' | translate
      },
      {
        value: TreatmentPlanDialogDate.All,
        label: 'charting_treatment_plan_date_all' | translate
      }
    ]"
    [value]="viewModel().dateOption"
    (valueChange)="onDateOptionChange($event)"
  />
</div>

@if (viewModel().treatmentList.length === 0) {
  <div class="flex h-full flex-col items-center justify-center gap-4 p-4">
    @if (viewModel().isLoading) {
      <ng-lottie currentcolor class="text-primary-blue" [options]="lottieOptions"></ng-lottie>
    } @else if (viewModel().isFetched) {
      <div class="flex h-[56px] w-[56px] items-center justify-center rounded-full bg-text-white">
        <svg-icon class="text-text-light" key="px-20-checklist" size="md"></svg-icon>
      </div>

      <span class="text-text-tertiary">{{ 'reason_selector_treatment_plan_no_result' | translate }}</span>
    }
  </div>
}

<div
  class="-ml-[26px] -mr-[26px] mt-6 flex min-h-0 flex-grow flex-col gap-2 overflow-y-auto rounded-bl-[48px] rounded-br-[48px] border-2 border-t-0 border-background-white pl-6 pr-6"
>
  @for (item of viewModel().treatmentList; track $index) {
    <div
      class="flex flex-col gap-2 rounded-2xl border-2 bg-background-card-lvl3 pb-4 pl-4 pr-3 pt-3"
      [ngClass]="isSelected(item) ? 'border-primary-blue' : 'border-background-white'"
    >
      <div class="flex items-center justify-between text-primary-blue">
        <div class="flex items-center gap-2">
          <div class="typo-h4-semibold">{{ item.dentalCode }}</div>
          @if (item.treatmentDescription) {
            <svg-icon
              class="text-text-light"
              key="px-16-info"
              size="sm"
              [libUiTooltip]="treatmentDescTooltip"
              tooltipPosition="bottom"
            ></svg-icon>
            <ng-template #treatmentDescTooltip>
              <div class="typo-h5-book min-w-[18px]">{{ item.treatmentDescription }}</div>
            </ng-template>
          }
        </div>

        <div class="flex items-center gap-1">
          @for (tag of item.tagsToShow; track $index) {
            @if (tag) {
              <div class="typo-h5-semibold h-[21px] rounded-lg bg-background-tag px-2 pt-[3px] text-primary-blue">
                {{ tag }}
              </div>
            }
          }

          <button class="btn-icon-small ml-2" (click)="isSelected(item) ? deselectItem(item) : selectItem(item)">
            <svg-icon
              key="px-16-plus"
              size="sm"
              class="transition-transform"
              [ngClass]="{
                'rotate-[135deg]': isSelected(item)
              }"
            />
          </button>
        </div>
      </div>
      <div class="typo-h4-medium flex items-center justify-between text-text-primary">
        <span>{{ item.treatmentName }}</span>
        <span class="mr-10">{{ item.formattedDate }}</span>
      </div>
    </div>
  }
</div>
